(function ($) {
  $.ajax({
    type: 'POST',
    url: pw_script_vars.ajaxurl,
    data: {
      action: 'add_post_view',
      post_id: pw_script_vars.page_id
    }
  }).done(( msg ) => {
    console.log(msg);
  });
}) (jQuery);